import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { Button, Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { useNavigate } from 'react-router-dom'
import type { NectarEnrollmentStatus, NectarProject } from '../api/models'

export type TerminalStatus = Exclude<NectarEnrollmentStatus, 'IN_PROGRESS' | 'PENDING_REVIEW'>

const STATUS_CONFIG = {
  APPROVED: {
    title: 'Project Complete',
    description: 'Your submission has been approved. Great work!',
    showReward: true,
    rewardPrefix: 'Earned'
  },
  REJECTED: {
    title: 'Submission Rejected',
    description: 'Unfortunately, your submission did not meet the requirements.',
    showReward: false,
    rewardPrefix: ''
  },
  EXPIRED: {
    title: 'Project Expired',
    description: 'This project has expired and is no longer accepting submissions.',
    showReward: false,
    rewardPrefix: ''
  }
}

export const NectarProjectStatusView = ({ project, status }: { project: NectarProject; status: TerminalStatus }) => {
  const navigate = useNavigate()
  const { missionsUrl } = useMissionsUrl()
  const config = STATUS_CONFIG[status]

  return (
    <>
      <div className="m-auto mt-10 flex w-[600px] flex-col items-center justify-center gap-4 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
        <Text type="h5" className="text-gray-70">
          {config.title}
        </Text>
        <div className="flex flex-col items-center justify-center">
          <Text type="body1-regular" className="text-gray-80">
            {config.description}
          </Text>
          {config.showReward &&
            !!project.rewardConfig?.amount &&
            (status === 'APPROVED' ? (
              project.enrollment?.earnedReward != null && (
                <Text type="body1-regular">
                  Earned <span className="text-green">{formatNumber(project.enrollment.earnedReward, 0)} points</span>!
                </Text>
              )
            ) : (
              <Text type="body1-regular" className="text-green">
                {config.rewardPrefix}{' '}
                <span className="text-green">{formatNumber(project.rewardConfig.amount, 0)} points</span>.
              </Text>
            ))}
        </div>
        <Button size="small" variant="bordered" onClick={() => navigate(missionsUrl)} className="mt-2">
          Back to Missions
        </Button>
      </div>
    </>
  )
}
